/* eslint-disable react-hooks/exhaustive-deps */
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { withStyles } from "@material-ui/core/styles";
import Switch from "@material-ui/core/Switch";
import Typography from "@material-ui/core/Typography"; 
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import VpnKeyOutlinedIcon from "@material-ui/icons/VpnKeyOutlined";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import InputAdornment from "@material-ui/core/InputAdornment";
import { createFilterOptions } from "@material-ui/lab/Autocomplete";

import AddCoach from "../../components/AddCoach";
import Autocomplete from "../../components/Autocomplete";
import TextField from "../../components/TextField";
import {
  AdminRole,
  IsCampaignAdmin,
  IsSuperAdmin,
  IsSupportAdmin,
  Role,
} from "../../config/Roles";

import styles from "./Settings.module.scss";

import { useTranslation } from "react-i18next";
import AddCoachee from "../../components/AddCoachee";
import AddCountries from "../../components/AddCountries";
import BackButton from "../../components/BackButton";
import Button from "../../components/Button";
import PageContent from "../../components/PageContent";
import Section from "../../components/Section";
import SectionTitle from "../../components/SectionTitle";
import SendgridCheck from "../../components/SendgridCheck";
import { useNotification } from "../../context/notification";
import { DashboardLayout } from "../../layouts/DashboardLayout";
import { apiRequest } from "../../utils/api";
import { getLocalValue } from "../../utils/auth";
import getUserIP, { formatIPJSON } from "../../utils/getUserIP";
import useDocumentTitle from "../../utils/useDocumentTitle";

const Accordion = withStyles({
  root: {
    border: "none",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: "#fff",
    borderBottom: "none",
    marginBottom: -1,
    minHeight: 20,
    "&$expanded": {
      minHeight: 20,
    },
  },
  content: {
    margin: "6px 0",
    "&$expanded": {
      margin: "6px 0",
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    flexWrap: "wrap",
  },
}))(MuiAccordionDetails);

export function EditUser(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams();
  useDocumentTitle(props.title);
  const { addNotification } = useNotification();
  const [userData, setUserData] = useState(null);
  const [campaignData, setCampaignData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [roleValue, setRoleValue] = useState(null);
  const [adminRoleValue, setAdminRoleValue] = useState(null);
  const [disableUserRole, setDisableUserRole] = useState(false);
  const [userStatus, setUserStatus] = useState("Active"); // New | Active | Inactive
  const [initialUserStatus, setInitialUserStatus] = useState("Active");
  const [statusConfirmOpen, setStatusConfirmOpen] = useState(false);
  const [pendingUserStatus, setPendingUserStatus] = useState(null);
  const [userBlock, setUserBlock] = useState(true);
  const [newPassword, setNewPassword] = useState(null);
  const [isPasswordChanged, setIsPasswordChanged] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [defaultCampaignID, setDefaultCampaignID] = useState(null);
  const [allCoaches, setAllCoaches] = useState(null);
  const [addCoachCheck, setAddCoachCheck] = useState(false);
  const [assignedCoaches, setAssignedCoaches] = useState([]);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isSupportAdmin, setIsSupportAdmin] = useState(false);
  const [isCampaignEditable, setIsCampaignEditable] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [primaryCountry, setPrimaryCountry] = useState({});
  const [isCoachee, setIsCoachee] = useState(false);
  const [isTempPasswordActive, setIsTempPasswordActive] = useState(false);
  const [tempPassword, setTempPassword] = useState(false);
  const [revetTempPassword, setRevetTempPassword] = useState(false);
  const [userIP, setUserIP] = useState(null);
  //Role coach
  const [coachCampaigns, setCoachCampaigns] = useState([]);
  const [allCoachees, setAllCoachees] = useState([]);
  const [manageCoacheeExpanded, setManageCoacheeExpanded] =
    React.useState(false);
  const [defaultCampaignDetail, setDefaultCampaignDetail] = useState({});
  const [isUserSynced, setIsUserSynced] = useState(false);

  async function fetchData() {
    setIsLoading(true);

    const response = await apiRequest.get(`/api/getUserDetails?uid=${id}`);

    if (response && response.status === 200) {
      const data = response.data.data;
      setUserData(data);
      setIsSuperAdmin(
        parseInt(getLocalValue("u_coaching_role")) === Role.SUPER_ADMIN
          ? true
          : false
      );
      setIsSupportAdmin(
        parseInt(getLocalValue("u_coaching_role")) === Role.SUPPORT_ADMIN
          ? true
          : false
      );
    } else {
      addNotification(
        t("error.couldNotGetSession") + `. (Status code: ${response})`,
        "error"
      );
    }
    setIsLoading(false);
  }

  async function fetchAllCampaign(url) {
    if (adminRoleValue !== null) {
      setIsLoading(true);

      const response = await apiRequest.get(url);

      if (response.status === 200) {
        let data = response.data.data;
        data = data.filter(option => {
          return option.region_id !== null;
        });
        data = data.filter(option => {
          return option.region_id !== 0;
        });
        data.sort((a, b) => a.region_id - b.region_id);
        setCampaignData(data);
      } else {
        addNotification(
          t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
          "error"
        );
      }
      setIsLoading(false);
    }
  }

  async function getAllCoaches(campaign_id) {
    const response = await apiRequest.post(`/api/getAllCoaches`, {
      campaign_ids: campaign_id,
      user_id: id,
    });
    if (response.status === 200) {
      const data = response.data.data;
      setAllCoaches(data);
    } else {
      addNotification(
        t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
        "error"
      );
    }
  }

  useEffect(() => {
    fetchData();
  }, [isUserSynced]);

  useEffect(() => {
    if (!IsCampaignAdmin()) {
      fetchAllCampaign("/api/getAllCampaigns?view=usermanagement");
    }
    if (IsCampaignAdmin()) {
      fetchAllCampaign(`/api/getUserCampaignList?uid=${getLocalValue("uid")}`);
    }
  }, [adminRoleValue]);

  useEffect(() => {
    getUserIP().then(res => setUserIP(formatIPJSON(res)));
  }, []);

  useEffect(() => {
    setIsCoachee(Role.COACHEE === parseInt(roleValue));
    setIsCampaignEditable(isSuperAdmin || isSupportAdmin || IsCampaignAdmin());
  }, [isSuperAdmin, isSupportAdmin, selectedCampaign, roleValue]);

  useEffect(() => {
    if (_.has(userData, "userInfo") && userData["userInfo"]["u_role"]) {
      setRoleValue(userData["userInfo"]["u_role"].toString());
    }

    if (
      _.has(userData, "userInfo") &&
      _.has(userData["userInfo"], "u_coaching_role")
    ) {
      setAdminRoleValue(userData["userInfo"]["u_coaching_role"]);
    }

    if (_.has(userData, "userInfo")) {
      const info = userData["userInfo"];
      const isNew =
        Number(info.is_modified_coaching) === 0 &&
        String(info.u_status) === "1";
      const displayStatus = isNew
        ? "New"
        : String(info.u_status) === "1"
          ? "Active"
          : "Inactive";
      setUserStatus(displayStatus);
      setInitialUserStatus(displayStatus);
    }

    if (_.has(userData, "userInfo")) {
      setUserBlock(userData["userInfo"]["u_block"] === "1" ? true : false);
    }

    if (_.has(userData, "userInfo")) {
      setIsTempPasswordActive(
        userData["userInfo"]["is_temporary_password"] ===
          "temp_password_not_set"
          ? false
          : true
      );
    }

    if (_.has(userData, "campaign") && userData["campaign"].length > 0) {
      userData["campaign"].forEach((item, index) => {
        if (!item.is_manual_tagging) {
          setSelectedCampaign(userData["campaign"][index]);
          setDefaultCampaignID(userData["campaign"][index].campaign_id);
          setDefaultCampaignDetail(userData["campaign"][index]);
        }
      });

      const newList = userData.campaign.filter(item => {
        return item.functional_unit !== null && item.functional_unit !== "";
      });

      setCoachCampaigns([...newList]);
    }
    if (_.has(userData, "coach")) {
      setAssignedCoaches(userData["coach"]);
    }

    if (_.has(userData, "userInfo")) {
      setPrimaryCountry({
        title: userData["userInfo"]["u_country"],
        id: userData["userInfo"]["region_id"],
        region_id: userData["userInfo"]["region_id"],
      });
    }
  }, [userData, isUserSynced]);

  useEffect(() => {
    if (_.has(userData, "regions") && userData["regions"].length > 0) {
      _.remove(userData["regions"], {
        region_id: primaryCountry.region_id,
      });
      setSelectedCountry(userData["regions"]);
    }
  }, [primaryCountry]);

  useEffect(() => {
    if (parseInt(roleValue) === Role.COACHEE && selectedCampaign) {
      getAllCoaches([selectedCampaign.campaign_id]);
    }

    if (parseInt(roleValue) === Role.COACH) {
      if (coachCampaigns.length > 0) {
        let campaignIds = [];
        [...coachCampaigns].map(campaign => {
          campaignIds.push(campaign.campaign_id);
        });
        getAllCoaches(campaignIds);
      }
    }
  }, [selectedCampaign, coachCampaigns, roleValue]);

  const getUserInfo = field => {
    return userData && userData["userInfo"]
      ? userData["userInfo"][field]
      : null;
  };

  //Handling Role Change
  const handleChange = event => {
    setRoleValue(event.target.value);
  };

  useEffect(() => {
    if (adminRoleValue) {
      if (
        parseInt(adminRoleValue) === AdminRole.CAMPAIGN_MANAGER ||
        parseInt(adminRoleValue) === AdminRole.COORDINATOR ||
        parseInt(adminRoleValue) === AdminRole.SUPPORT_ADMIN
      ) {
        setRoleValue("1");
        setDisableUserRole(true);
      } else if (parseInt(adminRoleValue) !== 0) {
        setDisableUserRole(true);
        setRoleValue("");
      } else {
        setDisableUserRole(false);
      }
    }
  }, [adminRoleValue]);

  //Handling Role Change
  const handleAdminRoleChange = event => {
    const val = event.target.value;
    setAdminRoleValue(parseInt(val));
    if (
      parseInt(val) === AdminRole.CAMPAIGN_MANAGER ||
      parseInt(val) === AdminRole.COORDINATOR ||
      parseInt(val) === AdminRole.SUPPORT_ADMIN
    ) {
      setRoleValue("1");
      setDisableUserRole(true);
    } else if (parseInt(val) !== 0) {
      setDisableUserRole(true);
      setRoleValue("");
    } else {
      setDisableUserRole(false);
    }
  };

  //Coach autocomplete can search with Employee Id and Employee name
  const filterOptions = createFilterOptions({
    stringify: option => `${option.u_fullname} ${option.employee_id}`,
  });

  //Add Campaigns to Coach
  const addCampaigns = campaign => {
    if (_.find(coachCampaigns, { campaign_id: campaign.campaign_id })) {
      addNotification(
        `Selected Functional unit is already in the list`,
        "error"
      );
      return;
    }
    campaign.coachee = [];
    setCoachCampaigns([
      { ...campaign, is_manual_tagging: 1 },
      ...coachCampaigns,
    ]);
  };

  //Delete Campaigns from Coach
  const deleteCampaigns = campaign => {
    const remainingItems = [
      ...coachCampaigns.filter(
        list => list.campaign_id !== campaign.campaign_id
      ),
    ];
    setCoachCampaigns(remainingItems);
  };

  //Delete Coachee list from Coache's campaign List
  const deleteCampaignCoachee = (coachee, campaignId) => {
    const remainingItems = [];
    [...coachCampaigns].map(item => {
      item.campaign_id === campaignId
        ? remainingItems.push({
          ...item,
          coachee: item.coachee.filter(
            child => child.employee_id !== coachee.employee_id
          ),
        })
        : remainingItems.push(item);
    });

    setCoachCampaigns(remainingItems);
  };

  const deleteAllCampaignCoachee = campaignId => {
    const remainingItems = [];
    [...coachCampaigns].map(item => {
      item.campaign_id === campaignId
        ? remainingItems.push({
          ...item,
          coachee: [],
        })
        : remainingItems.push(item);
    });

    setCoachCampaigns(remainingItems);
  };

  //add Coachee list from Coache's campaign List
  const addAllCampaignCoachee = (coachee, campaignId) => {
    const currentItems = [...coachCampaigns].map(item => {
      const newList =
        campaignId === item.campaign_id ? coachee : [...item.coachee];

      return {
        ...item,
        coachee: newList,
      };
    });

    setCoachCampaigns(currentItems);
  };

  //add Coachee list from Coache's campaign List
  const addCampaignCoachee = (coachee, campaignId) => {
    const currentItems = [...coachCampaigns].map(item => {
      const newList =
        campaignId === item.campaign_id
          ? item.coachee
            ? [...item.coachee].concat(coachee)
            : [].concat(coachee)
          : [...item.coachee];

      return {
        ...item,
        coachee: newList,
      };
    });

    setCoachCampaigns(currentItems);
  };

  const changePassword = event => {
    setNewPassword(event.target.value);
  };

  const resetPassword = () => {
    setIsPasswordChanged(true);
    const length = 5,
      charset = "abcdefghijklmnopqrstuvwxyz",
      charsetUpper = "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      numbers = "0123456789",
      specialCharacter = "@!#$%*~";
    let retVal = "";

    for (let i = 0; i < length; ++i) {
      retVal += charset.charAt(Math.floor(Math.random() * 10));
    }

    for (let i = 0; i < length; ++i) {
      retVal += charsetUpper.charAt(Math.floor(Math.random() * 10));
    }
    retVal += numbers.charAt(Math.floor(Math.random() * 10));
    retVal += specialCharacter.charAt(Math.floor(Math.random()));
    setNewPassword(retVal);
  };

  const getSelectedCampaignDetails = () => {
    const userCampaign = [];
    coachCampaigns.map(list => {
      const coacheeCampaign = {
        campaign_id: list.campaign_id,
        functional_unit: list.functional_unit,
        is_manual_tagging: list.is_manual_tagging,
      };
      userCampaign.push(coacheeCampaign);
    });
    return userCampaign;
  };

  const getSelectedCampaignDetailsForCoachee = () => {
    return [
      {
        campaign_id: selectedCampaign.campaign_id,
        functional_unit: selectedCampaign.functional_unit,
        is_manual_tagging:
          selectedCampaign.is_manual_tagging === 0
            ? selectedCampaign.is_manual_tagging
            : 1,
      },
    ];
  };

  const getAssignedCoaches = () => {
    const coaches = [];
    assignedCoaches.map(list => {
      const coach = {
        uid: list.uid || list.coach_id,
        u_fullname: list.u_fullname,
        campaign_id: list.campaign_id,
      };
      coaches.push(coach);
    });
    return coaches;
  };

  const getAssignedCoachees = () => {
    const coachees = [];
    if (parseInt(roleValue) === Role.COACH) {
      coachCampaigns.map(list => {
        list.coachee &&
          list.coachee.map(coachee => {
            if (coachee) {
              const coach = {
                uid: coachee.uid,
                u_fullname: coachee.u_fullname,
                campaign_id: list.campaign_id,
              };
              coachees.push(coach);
            }
          });
      });
    }
    return coachees;
  };

  const updateUserDetails = async () => {
    //User Role validation

    if (adminRoleValue === 0 && !roleValue) {
      addNotification(`please select User Role`, "error");
      return;
    }

    const formData = {
      uid: id,
      userIP: userIP,
      u_role: parseInt(roleValue),
      u_coaching_role: adminRoleValue.toString(),
      created_by: getLocalValue("uid"),
      campaigns:
        Role.COACHEE === parseInt(roleValue)
          ? getSelectedCampaignDetailsForCoachee()
          : getSelectedCampaignDetails(),
      coaches: getAssignedCoaches(),
      coachees: getAssignedCoachees(),
    };

    if (tempPassword) {
      formData["temporary_reset_password"] = true;
    }

    if (revetTempPassword) {
      formData["revert_password"] = true;
    }

    if (adminRoleValue === AdminRole.EXECUTIVE) {
      if (selectedCountry) {
        formData.regions = [...selectedCountry, primaryCountry];
      } else {
        formData.regions = [primaryCountry];
      }
    }

    if (isPasswordChanged) {
      const newPass = newPassword;
      const lengthCheck = newPass.length >= 12;
      const numberCheck = /\d/.test(newPass);
      const specialCheck = /[ !"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]/.test(
        newPass
      );
      const upperCaseCheck = /[A-Z]/.test(newPass);
      if (lengthCheck && numberCheck && specialCheck && upperCaseCheck) {
        formData.password = newPassword;
      } else {
        addNotification(
          `Password must be at least 12 characters long, one number, one special character and one upper case letter`,
          "error"
        );
        return;
      }
    }
    setIsLoading(true);
    const response = await apiRequest.post(`/api/updateUserDetails`, formData);
    if (response.status === 200) {
      const data = response.data.data;
      updateUserStatus();
      updateUserBlockStatus();
    } else {
      setIsLoading(false);
      addNotification(
        `Could not save user details - ${response.data.error} . (Status code: ${response.status})`,
        "error"
      );
    }
  };

  const updateUserStatus = async () => {
    // New: no status DB update needed
    if (userStatus === "New") {
      return;
    }
    const formData = {
      uid: id,
      status: userStatus === "Inactive" ? "2" : "1",
      created_by: getLocalValue("uid"),
      userIP: userIP,
    };
    const response = await apiRequest.post(`/api/changeUserStatus`, formData);
    if (response.status === 200) {
      const data = response.data.data;
      setIsLoading(false);
      addNotification(t("userManagement.userDetailsUp"), "success");
      // history.push("/settings/userManagement/");
    } else {
      setIsLoading(false);
      addNotification(
        `Could not update user status . (Status code: ${response.status})`,
        "error"
      );
    }
  };

  const updateUserBlockStatus = async () => {
    //setUserStatus
    const formData = {
      uid: id,
      status: userBlock ? "1" : "2",
      created_by: getLocalValue("uid"),
      userIP: userIP,
    };
    const response = await apiRequest.post(
      `/api/changeUserBlockStatus`,
      formData
    );
    if (response.status === 200) {
      const data = response.data.data;
      setIsLoading(false);
      addNotification(t("userManagement.userDetailsUp"), "success");
      // history.push("/settings/userManagement/");
    } else {
      setIsLoading(false);
      addNotification(
        `Could not update user Block status . (Status code: ${response.status})`,
        "error"
      );
    }
  };

  const syncFlashHomeData = async () => {
    setIsLoading(true);
    const response = await apiRequest.post(
      `/api/updateUserDetailsFromFlashHomeByEmpID?empId=${getUserInfo(
        "employee_id"
      )}`
    );
    if (response.status === 200) {
      setIsLoading(false);
      setIsUserSynced(!isUserSynced);
      addNotification(
        `Flash Home Data has been synced successfully!`,
        "success"
      );
    } else {
      setIsLoading(false);
      addNotification(
        `Flash Home Data syncing failed - ${response.data.error} . (Status code: ${response.status})`,
        "error"
      );
    }
  };

  const reset2Fa = async () => {
    const formData = {
      email_address: `${getUserInfo("primary_email")}`,
    };
    setIsLoading(true);
    const response = await apiRequest.post(`/api/user/reset/2fa`, formData);
    if (response.status === 200) {
      setIsLoading(false);
      addNotification(`User 2fa has been reset successfully!`, "success");
    } else {
      setIsLoading(false);
      addNotification(
        `User 2fa reset failed - ${response.data.error} . (Status code: ${response.status})`,
        "error"
      );
    }
  };

  const resetSecurityQuestions = async () => {
    if (!id) return;
    setIsLoading(true);
    try {
      const userIp = await getUserIP();
      const response = await apiRequest.post(
        `/api/security-questions/admin/reset/${id}`,
        {
          userIp: formatIPJSON(userIp),
        }
      );

      if (response.status === 200) {
        addNotification(
          t("userManagement.resetSecurityQuestionsSuccess"),
          "success"
        );
      } else {
        addNotification(
          `${t("userManagement.resetSecurityQuestionsFailed")} (Status: ${response.status})`,
          "error"
        );
      }
    } catch (error) {
      addNotification(t("userManagement.resetSecurityQuestionsError"), "error");
    }
    setIsLoading(false);
  };

  return (
    <DashboardLayout isDisableCampaignSelection={true}>
      <div className={styles.pageWrapper}>
        <PageContent>
          <Section>
            <div className={styles.profileContainer}>
              <div className={styles.backButtonWrapper}>
                <BackButton />
              </div>
              <div className={styles.profileWrapper}>
                <SectionTitle>{t("userManagement.editUser")}</SectionTitle>
                {userData && (
                  <form>
                    <div className={styles.detailsContainer}>
                      <div className={styles.profileRow}>
                        <div className={styles.rowLeft}>
                          {t("userManagement.fullName")}
                        </div>
                        <div className={styles.rowRight}>
                          {getUserInfo("u_fullname")}
                        </div>
                      </div>
                      {IsSupportAdmin() | IsSuperAdmin() | IsCampaignAdmin() ? (
                        <div className={styles.profileRow}>
                          <div className={styles.rowLeft}>User Name</div>
                          <div className={styles.rowRight}>
                            {getUserInfo("u_username")}
                          </div>
                        </div>
                      ) : null}

                      <div className={styles.profileRow}>
                        <div className={styles.rowLeft}>
                          {t("userManagement.employeeID")}
                        </div>
                        <div className={styles.rowRight}>
                          {getUserInfo("employee_id")}
                        </div>
                      </div>
                      {IsSupportAdmin() | IsSuperAdmin() ? (
                        <>
                          <div className={styles.profileRow}>
                            <div className={styles.rowLeft}>Primary Email</div>
                            <div className={styles.rowRight}>
                              {getUserInfo("primary_email")}
                            </div>
                          </div>
                          <div className={styles.profileRow}>
                            <div className={styles.rowLeft}>Personal Email</div>
                            <div className={styles.rowRight}>
                              {getUserInfo("personal_email")}
                            </div>
                          </div>
                        </>
                      ) : null}
                      <div className={styles.profileRow}>
                        <div className={styles.rowLeft}>
                          {t("userManagement.designation")}
                        </div>
                        <div className={styles.rowRight}>
                          {getUserInfo("u_designation")}
                        </div>
                      </div>
                      {adminRoleValue !== AdminRole.EXECUTIVE && (
                        <div className={styles.profileRow}>
                          <div className={styles.rowLeft}>
                            {t("userManagement.country")}
                          </div>
                          <div className={styles.rowRight}>
                            {getUserInfo("u_country")}
                          </div>
                        </div>
                      )}
                      {!IsCampaignAdmin() && (
                        <div
                          className={styles.profileRow}
                          style={{ alignItems: "flex-start" }}
                        >
                          <div className={styles.rowLeft}>
                            {t("userManagement.adminRole")}
                          </div>
                          <div className={styles.rowRight}>
                            <FormControl component="fieldset">
                              <RadioGroup
                                aria-label="role"
                                name="adminRole"
                                value={adminRoleValue}
                                onChange={handleAdminRoleChange}
                                row
                              >
                                <FormControlLabel
                                  className={styles.labelOption}
                                  value={0}
                                  control={
                                    <Radio className={styles.radioOption} />
                                  }
                                  label="Normal User"
                                />
                                <FormControlLabel
                                  className={styles.labelOption}
                                  value={AdminRole.CAMPAIGN_MANAGER}
                                  control={
                                    <Radio className={styles.radioOption} />
                                  }
                                  label="Functional Unit Manager"
                                />
                                <FormControlLabel
                                  className={styles.labelOption}
                                  value={AdminRole.COORDINATOR}
                                  control={
                                    <Radio className={styles.radioOption} />
                                  }
                                  label="Coordinator"
                                />
                                <FormControlLabel
                                  className={styles.labelOption}
                                  value={AdminRole.COE_ADMIN}
                                  control={
                                    <Radio className={styles.radioOption} />
                                  }
                                  label="COE"
                                />
                                <FormControlLabel
                                  className={styles.labelOption}
                                  value={AdminRole.EXECUTIVE}
                                  control={
                                    <Radio className={styles.radioOption} />
                                  }
                                  label="Executive"
                                />
                              </RadioGroup>
                            </FormControl>
                          </div>
                        </div>
                      )}
                      <div
                        className={styles.profileRow}
                        style={{ alignItems: "flex-start" }}
                      >
                        <div className={styles.rowLeft}>
                          {t("userManagement.role")}
                        </div>
                        <div className={styles.rowRight}>
                          <FormControl component="fieldset">
                            <RadioGroup
                              aria-label="role"
                              name="role"
                              value={roleValue}
                              onChange={handleChange}
                              row
                            >
                              <FormControlLabel
                                disabled={disableUserRole}
                                className={styles.labelOption}
                                value="2"
                                control={
                                  <Radio className={styles.radioOption} />
                                }
                                label="Coachee"
                              />
                              <FormControlLabel
                                disabled={disableUserRole}
                                className={styles.labelOption}
                                value="1"
                                control={
                                  <Radio className={styles.radioOption} />
                                }
                                label="Coach"
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>

                      {campaignData &&
                        adminRoleValue !== AdminRole.EXECUTIVE && (
                          <>
                            <div className={styles.profileRow}>
                              <div
                                className={styles.rowLeft}
                                style={{ paddingTop: "16px" }}
                              >
                                {t("userManagement.campaign")}
                              </div>
                              <div
                                className={styles.rowRight}
                                style={{
                                  display: "flex",
                                  alignItems: "flex-end",
                                }}
                              >
                                {!isCoachee && isCampaignEditable ? (
                                  <Autocomplete
                                    defaultValue={campaignData[0]}
                                    onChange={(event, newValue) => {
                                      setSelectedCampaign(newValue);
                                    }}
                                    disabled={!isCampaignEditable || isCoachee}
                                    options={campaignData}
                                    groupBy={option => option.region_name}
                                    getOptionLabel={option =>
                                      option.functional_unit +
                                      `
                                    ${option.sub_functional_unit
                                        ? " (" +
                                        option.sub_functional_unit +
                                        ")"
                                        : ""
                                      }`
                                    }
                                    style={{ width: 760 }}
                                    renderInput={params => (
                                      <TextField
                                        {...params}
                                        placeholder="Select Functional Unit"
                                        variant="outlined"
                                      />
                                    )}
                                  />
                                ) : (
                                  <span>
                                    {defaultCampaignDetail.functional_unit}
                                    {defaultCampaignDetail.sub_functional_unit && (
                                      <span>
                                        (
                                        {
                                          defaultCampaignDetail.sub_functional_unit
                                        }
                                        )
                                      </span>
                                    )}
                                  </span>
                                )}

                                {(parseInt(roleValue) === Role.COACH ||
                                  parseInt(adminRoleValue) ===
                                  AdminRole.COE_ADMIN) &&
                                  !!isCampaignEditable && (
                                    <Button
                                      variant="outlined"
                                      color="secondary"
                                      size="small"
                                      style={{ marginLeft: "6px" }}
                                      disabled={!selectedCampaign}
                                      onClick={() => {
                                        addCampaigns(selectedCampaign);
                                      }}
                                    >
                                      {t("userManagement.add")}
                                    </Button>
                                  )}
                              </div>
                            </div>

                            {!isSuperAdmin &&
                              !isSupportAdmin &&
                              parseInt(roleValue) === Role.COACH && (
                                <div
                                  className={styles.rowLeft}
                                  style={{ height: "25px" }}
                                ></div>
                              )}
                            {allCoaches &&
                              parseInt(roleValue) === Role.COACHEE && (
                                <AddCoach
                                  coachList={assignedCoaches}
                                  filterOptions={filterOptions}
                                  allCoaches={allCoaches}
                                  defaultCampaignID={defaultCampaignID}
                                  label={t("logs.coach")}
                                  onUpdateCoachList={coachList => {
                                    setAssignedCoaches(coachList);
                                  }}
                                />
                              )}
                          </>
                        )}

                      {!_.isEmpty(coachCampaigns) &&
                        (parseInt(roleValue) === Role.COACH ||
                          parseInt(adminRoleValue) === AdminRole.COE_ADMIN) && (
                          <>
                            <div
                              className={styles.profileRow}
                              style={{
                                marginTop: `${!isSuperAdmin && !isSupportAdmin
                                  ? "-40px"
                                  : ""
                                  }`,
                              }}
                            >
                              <div className={styles.rowLeft}></div>
                              <div className={styles.rowRight}>
                                <div className={styles.campaignWrapper}>
                                  {coachCampaigns.map((item, index) => (
                                    <div
                                      key={index}
                                      className={styles.campaignItem}
                                    >
                                      <div className={styles.selectedCampaign}>
                                        <span className={styles.count}>
                                          {index + 1}
                                        </span>
                                        <h5 className={styles.campaignHead}>
                                          {item.functional_unit}
                                          {item.sub_functional_unit && (
                                            <span>
                                              ( {item.sub_functional_unit} )
                                            </span>
                                          )}
                                        </h5>
                                        {(isSuperAdmin ||
                                          isSupportAdmin ||
                                          IsCampaignAdmin()) &&
                                          item.is_manual_tagging ? (
                                          <DeleteIcon
                                            onClick={() => {
                                              deleteCampaigns(item);
                                            }}
                                            style={{
                                              color: "#9E9E9E",
                                              fontSize: 16,
                                              cursor: "pointer",
                                              float: "right",
                                            }}
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                      {parseInt(adminRoleValue) !==
                                        AdminRole.COE_ADMIN && (
                                          <div
                                            className={
                                              styles.manageCoacheeWrapper
                                            }
                                          >
                                            <Accordion
                                              square
                                              onChange={(e, expanded) => {
                                                if (expanded) {
                                                  setManageCoacheeExpanded(
                                                    "coachee" + index
                                                  );
                                                }
                                              }}
                                            >
                                              <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls={`panel${index}d-header`}
                                                id={`panel${index}d-header`}
                                              >
                                                <Typography>
                                                  {t(
                                                    "userManagement.managerCoache"
                                                  )}
                                                </Typography>
                                              </AccordionSummary>
                                              <AccordionDetails>
                                                <AddCoachee
                                                  coacheeList={item.coachee}
                                                  filterOptions={filterOptions}
                                                  campaignId={item.campaign_id}
                                                  userLevelId={getUserInfo(
                                                    "u_levelid"
                                                  )}
                                                  // allCoachees={allCoachees[index]}
                                                  addCampaignCoachee={selectedCoachee => {
                                                    addCampaignCoachee(
                                                      selectedCoachee,
                                                      item.campaign_id
                                                    );
                                                  }}
                                                  deleteCampaignCoachee={coachee => {
                                                    deleteCampaignCoachee(
                                                      coachee,
                                                      item.campaign_id
                                                    );
                                                  }}
                                                  deleteAllCampaignCoachee={() => {
                                                    deleteAllCampaignCoachee(
                                                      item.campaign_id
                                                    );
                                                  }}
                                                  addAllCampaignCoachee={selectedCoachee => {
                                                    addAllCampaignCoachee(
                                                      selectedCoachee,
                                                      item.campaign_id
                                                    );
                                                  }}
                                                />
                                              </AccordionDetails>
                                            </Accordion>

                                            {(parseInt(roleValue) ===
                                              Role.COACHEE ||
                                              parseInt(roleValue) ===
                                              Role.COACH) && (
                                                <>
                                                  <AddCoach
                                                    coachList={assignedCoaches}
                                                    child={true}
                                                    campaignId={item.campaign_id}
                                                    filterOptions={filterOptions}
                                                    allCoaches={
                                                      allCoaches &&
                                                      allCoaches.filter(coach => {
                                                        const campaignIds =
                                                          coach.campaign_id.split(
                                                            ","
                                                          );

                                                        let currentCampaignId = [];
                                                        campaignIds.forEach(
                                                          campaignID => {
                                                            if (
                                                              parseInt(
                                                                campaignID
                                                              ) === item.campaign_id
                                                            ) {
                                                              currentCampaignId.push(
                                                                true
                                                              );
                                                            }
                                                          }
                                                        );

                                                        if (
                                                          currentCampaignId.length >
                                                          0
                                                        ) {
                                                          return coach;
                                                        }
                                                      })
                                                    }
                                                    onUpdateCoachList={coachList => {
                                                      setAssignedCoaches(coachList);
                                                    }}
                                                  />
                                                </>
                                              )}
                                          </div>
                                        )}
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                      {adminRoleValue === AdminRole.EXECUTIVE && (
                        <AddCountries
                          primaryCountry={primaryCountry}
                          list={selectedCountry}
                          addedCountries={country => {
                            setSelectedCountry(country);
                          }}
                        />
                      )}
                      <div
                        className={styles.profileRow}
                        style={{ alignItems: "flex-start" }}
                      >
                        <div className={styles.rowLeft}>
                          {t("userManagement.userStatus")}
                        </div>
                        <div className={styles.rowRight}>
                          <FormControl component="fieldset">
                            <RadioGroup
                              aria-label="userStatus"
                              name="userStatus"
                              value={userStatus}
                              onChange={e => {
                                const nextStatus = e.target.value;
                                if (
                                  initialUserStatus === "New" &&
                                  nextStatus !== "New"
                                ) {
                                  setPendingUserStatus(nextStatus);
                                  setStatusConfirmOpen(true);
                                  return;
                                }
                                setUserStatus(nextStatus);
                              }}
                              row
                            >
                              {initialUserStatus === "New" && (
                                <FormControlLabel
                                  className={styles.labelOption}
                                  value="New"
                                  control={
                                    <Radio className={styles.radioOption} />
                                  }
                                  label="New"
                                />
                              )}
                              <FormControlLabel
                                className={styles.labelOption}
                                value="Active"
                                control={
                                  <Radio className={styles.radioOption} />
                                }
                                label="Active"
                              />
                              <FormControlLabel
                                className={styles.labelOption}
                                value="Inactive"
                                control={
                                  <Radio className={styles.radioOption} />
                                }
                                label="Inactive"
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                      {(isSupportAdmin || isSuperAdmin) && (
                        <div className={styles.profileRow}>
                          <div className={styles.rowLeft}>
                            {t("userManagement.userBlock")}
                          </div>
                          <div className={styles.rowRight}>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={userBlock}
                                  onChange={e => {
                                    setUserBlock(e.target.checked);
                                  }}
                                  name="userBlock"
                                />
                              }
                              label={userBlock ? "Unblocked" : "Blocked"}
                            //active: 1
                            //inactive: 2
                            />
                          </div>
                        </div>
                      )}
                      {(isSupportAdmin || isSuperAdmin) && (
                        <div className={styles.profileRow}>
                          <div className={styles.rowRight}>
                            <Button
                              margin={styles.addBtn}
                              className={styles.addBtn}
                              variant="contained"
                              color="primary"
                              onClick={syncFlashHomeData}
                            >
                              Sync Flash Home Data
                            </Button>
                          </div>
                          <div className={styles.rowRight}
                            style={{ marginLeft: "48px" }}>
                            <Button
                              className={styles.addBtn}
                              variant="contained"
                              color="primary"
                              onClick={reset2Fa}
                            >
                              Reset 2fa
                            </Button>
                          </div>
                          <div className={styles.rowRight}>
                            <Button
                              className={styles.addBtn}
                              variant="contained"
                              color="primary"
                              onClick={resetSecurityQuestions}
                            >
                              Reset Security Questions
                            </Button>
                          </div>
                        </div>
                      )}

                      <div
                        className={styles.profileRow}
                        style={{ flexWrap: "wrap" }}
                      >
                        <div
                          className={`${styles.rowLeft} ${styles.resetPasswordLabel}`}
                          onClick={resetPassword}
                        >
                          <VpnKeyOutlinedIcon />
                          {t("userManagement.resetPassword")}
                        </div>
                        {isSupportAdmin && <SendgridCheck email={getUserInfo("primary_email")} />}
                        {isPasswordChanged && (
                          <>
                            <div
                              className={styles.rowRight}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                paddingBottom: "0",
                              }}
                            >
                              <TextField
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <FileCopyOutlinedIcon
                                        style={{
                                          cursor: "pointer",
                                          color: "#9E9E9E",
                                        }}
                                        onClick={() => {
                                          navigator.clipboard.writeText(
                                            newPassword
                                          );
                                          addNotification(
                                            `Password Copied...!`,
                                            "success"
                                          );
                                        }}
                                      />
                                    </InputAdornment>
                                  ),
                                }}
                                value={newPassword}
                                name="resetPassword"
                                variant="outlined"
                                onChange={e => {
                                  changePassword(e);
                                }}
                              />
                              <CloseIcon
                                style={{
                                  color: "#757575",
                                  fontSize: "26px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  setIsPasswordChanged(false);
                                }}
                              />
                            </div>
                            <div
                              className={styles.rowRight}
                              style={{ marginLeft: "180px", paddingTop: "5px" }}
                            >
                              {t("userManagement.pleaseSaveToResetThe")}
                            </div>
                          </>
                        )}
                      </div>
                      {IsSupportAdmin() && !isTempPasswordActive && (
                        <div className={styles.profileRow}>
                          <div className={styles.rowLeft}>
                            Reset Password Temporarily
                          </div>
                          <div className={styles.rowRight}>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={tempPassword}
                                  onChange={e => {
                                    setTempPassword(e.target.checked);
                                  }}
                                  name="temporary_reset_password"
                                />
                              }
                              label={tempPassword ? "Yes" : "No"}
                            //active: 1
                            //inactive: 2
                            />
                          </div>
                        </div>
                      )}
                      {IsSupportAdmin() && isTempPasswordActive && (
                        <div className={styles.profileRow}>
                          <div className={styles.rowLeft}>
                            Revert to the original password
                          </div>
                          <div className={styles.rowRight}>
                            <FormControlLabel
                              control={
                                <Switch
                                  checked={revetTempPassword}
                                  onChange={e => {
                                    setRevetTempPassword(e.target.checked);
                                  }}
                                  name="revert_password"
                                />
                              }
                              label={revetTempPassword ? "Yes" : "No"}
                            //active: 1
                            //inactive: 2
                            />
                          </div>
                        </div>
                      )}
                      <div>
                        <Button
                          variant="contained"
                          color="primary"
                          fullWidth
                          isloading={isLoading ? 1 : 0}
                          onClick={updateUserDetails}
                        >
                          {t("userManagement.saveChanges")}
                        </Button>
                      </div>
                      <div>
                        <Button
                          variant="outlined"
                          fullWidth
                          style={{
                            marginTop: "10px",
                            border: "none",
                            color: "#757575",
                          }}
                          onClick={() => {
                            history.push("/settings/userManagement/");
                          }}
                        >
                          {t("userManagement.cancel")}
                        </Button>
                      </div>
                    </div>
                  </form>
                )}
                <div></div>
              </div>
            </div>
          </Section>
        </PageContent>
      </div>
      <Dialog
        open={statusConfirmOpen}
        onClose={() => {
          setStatusConfirmOpen(false);
          setPendingUserStatus(null);
        }}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>User Status Update</DialogTitle>
        <DialogContent>
          <div>
            <strong>
              {userData?.userInfo?.u_fullname ||
                userData?.userInfo?.u_username ||
                "User"}
            </strong>
            <ul className="mt-2">
              <li>Status → {pendingUserStatus}</li>
            </ul>
          </div>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setStatusConfirmOpen(false);
              setPendingUserStatus(null);
            }}
            color="primary"
          >
            Cancel
          </Button>
          <Button
            onClick={() => {
              if (pendingUserStatus) {
                setUserStatus(pendingUserStatus);
              }
              setStatusConfirmOpen(false);
              setPendingUserStatus(null);
            }}
            color="primary"
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}
